import { useCallback, useEffect } from 'react'
import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikSelect, FormikInspectorAgreeCheck, billingDetailsSchema, FormikBillingDetails, FormikNotesArea, BillMode} from "../../../../../../components/widgets"
import { useAuth } from "../../../../../auth";
import { useUserLoader } from '../../../../../core/users';

import { remove, sortBy } from 'lodash';
import { isPopulatedArray } from '../../../../../../components/helpers';
import { IWebFileAttachment } from '../../../../../core/applications';

// Site Inspection
export interface IDLMSelectReviewer  {
  verdict: string 
  workflow: string
  inspectorID: number
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectorAgree: boolean
}

export const initDLMSelectReviewerValues: IDLMSelectReviewer = {
  verdict: '', 
  workflow: '',
  inspectorID: 0,    
  note: '',
  noteAttachments: [],          
  inspectorAgree: false,    
}

export const DLMSelectReviewerSchema: any = Yup.object({
  verdict: Yup.string().trim(),    
  workflow: Yup.string().trim(),    
  inspectorID: Yup.number().integer().label('Inspector')
  .when('verdict', {
      is : (verdict: string) => (verdict === 'approved'),
      then: (schema) => schema.required().moreThan(0, 'Select Inspector'),
  }),                
  note: Yup.string().trim().label('Note')
  .when(['appState', 'verdict'], {
    is : (appState: string, verdict: string) => (verdict !== 'approved' || appState === 'Site Inspection'),
    then: (schema) => schema.required(),
  }),    
  noteAttachments: Yup.array(),      
  inspectorAgree: Yup.bool().label('Confirmation')
  .when('verdict', {
    is: (val: string) => (val === 'approved'),
    then: (schema) => schema.oneOf([true], 'Must be checked'),    
  }),
}).concat(billingDetailsSchema);

export const DLMSelectReviewerForm = () => {

  const { values, setFieldValue, validateField } = useFormikContext();

  const { currentUser } = useAuth();
  
  const verdict = getIn(values, 'verdict') ?? '';        
  const appState = getIn(values, 'appState') ?? '';        
  

  const select = useCallback((data:any) => {
    if (! isPopulatedArray(data)) return [];
    if (appState === 'Site Inspection' && currentUser && currentUser?.id) {
        remove(data, (o: any) => (o.id && o.id > 0 && o.id === currentUser.id));
    }
    return sortBy(data.map((o: any) => ({ value: o.id, text: o.name})), ['text'], ['asc']);                
  },[currentUser, appState]);

  const { data: inspectors } = useUserLoader({userType: 'DLM Inspector', select});

  useEffect(() => {
    const VERDICT_BILLING_MAP: Record<string, BillMode> = {
      approved: 'YES',
      rejected: 'OPTIONAL',
    };

    // Falls back to 'NO' if verdict is not in the map
    const billingRequired = VERDICT_BILLING_MAP[verdict] ?? 'NO';
    setFieldValue('billingRequired', billingRequired, true);
    
    validateField('note');
    validateField('inspectorAgree');
        
  }, [verdict, setFieldValue, validateField]);
  
  return (
  <>
  { (verdict === 'approved') && 
  <div className="row mb-4">                
    <FormikSelect size="6" label="Assign Inspector" name="inspectorID" required={true} options={inspectors} placeholder={appState === 'Site Inspection' ? 'Select Inspector Reviewer' : 'Select Inspector'} />
  </div>
  }        
  <FormikBillingDetails />    
  <FormikNotesArea required={verdict !== 'approved' || appState === 'Site Inspection'} />
  { (verdict === 'approved') && 
  <FormikInspectorAgreeCheck />
  }
  </>
  )
}